export function extractIds(filesIds) {
  return filesIds.reduce((acc, item) => [...acc, item.id], [])
 }